import { renderDeviceName } from "../../utils/utils";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";

const orgColumn = {
  size: 80,
  muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
  enableColumnFilter: true,
  filterFn: "contains",
  accessorKey: "org_name",
  filterVariant: "select",
  muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
  header: "Organizzazione",
};

const patientColumn = {
  size: 80,
  muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
  enableColumnFilter: true,
  filterFn: "contains",
  accessorKey: "patient_info",
  filterVariant: "select",
  muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
  header: "Paziente",
};

const kitColumn = {
  size: 80,
  muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
  enableColumnFilter: true,
  filterFn: "contains",
  accessorKey: "kit_name",
  filterVariant: "select",
  muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
  header: "Kit",
};

const baseColumns = [
  {
    size: 120,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    enableColumnFilter: true,
    filterFn: "contains",
    accessorFn: (row) => renderDeviceName(row.device_type),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Tipo di Dispositivo",
  },
  {
    size: 50,
    header: "Dispositivo",
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    enableColumnFilter: true,
    filterFn: "contains",
    accessorKey: "name",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
  },
];

const tailColumns = [
  {
    size: 80,
    muiTableHeadCellFilterTextFieldProps: { placeholder: "Cerca" },
    enableColumnFilter: true,
    accessorKey: "serial_number",
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "MAC address",
  },
  {
    size: 5,
    accessorKey: "is_installed",
    enableColumnFilter: false,
    accessorFn: (row) => (row.is_installed ? "true" : "false"),
    filterVariant: "checkbox",
    Cell: ({ cell }) =>
      cell.getValue() === "true" ? (
        <DoneIcon color="success" />
      ) : (
        <CloseIcon color="error" />
      ),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Installato",
  },
  {
    size: 5,
    accessorKey: "is_online",
    enableColumnFilter: false,
    accessorFn: (row) => (row.is_online ? "true" : "false"),
    filterVariant: "checkbox",
    Cell: ({ cell }) =>
      cell.getValue() === "true" ? (
        <DoneIcon color="success" />
      ) : (
        <CloseIcon color="error" />
      ),
    muiTableHeadCellProps: { sx: { fontWeight: "bold" } },
    header: "Online",
  },
];

/** Medico: Paziente + Kit. Superadmin/admin: Organizzazione + Paziente + Kit. */
export const getDevicesColumns = ({ showOrg, showPatient, showKit = true }) => {
  const middle = [];
  if (showOrg) middle.push(orgColumn);
  if (showPatient) middle.push(patientColumn);
  if (showKit) middle.push(kitColumn);
  return [...baseColumns, ...middle, ...tailColumns];
};

export default getDevicesColumns({ showOrg: true, showPatient: false });
